import { gql } from '@apollo/client';

export const GET_BLOCKS_AND_TOTAL_BY_TITLE = gql`
  query blocksAndTotalByTitle($offset: Int, $limit: Int, $titleId: String) {
    blocksAndTotalByTitle(filter: {
      offset: $offset,
      limit: $limit,
      titleId: $titleId
    }) {
      blocks {
        id,
        titleId,
        subtitle,
        content,
        priority,
        brandId,
        productId,
      }
      total
    }
  }
`;

export const CREATE_BLOCKS = gql`
  mutation createBlock($input: [BlockInput!]!) {
    createBlock(input: $input) {
      id,
      subtitle,
      priority,
    }
  }  
`;

export const DELETE_BLOCK = gql`
  mutation deleteBlock($id: String!) {
    deleteBlock(id: $id) {
      id,
      subtitle,
    }
  }  
`;

export const UPDATE_BLOCK = gql`
  mutation updateBlock($id: String!, $titleId: String!, $subtitle: String!, $content: String!, $priority: Int!, $brandId: String, $productId: String) {
    updateBlock(id: $id, input: {
      titleId: $titleId,
      subtitle: $subtitle,
      content: $content,
      priority: $priority,
      brandId: $brandId,
      productId: $productId,
    }) {
      id
      subtitle,
    }
  }  
`;

export const UPDATE_BLOCK_PRIORITY = gql`
  mutation updateBlockPriority($titleId: String!, $blockId: String!, $blockIdReplaced: String!) {
    updateBlockPriority(titleId: $titleId, blockId: $blockId, blockIdReplaced: $blockIdReplaced) {
      id,
      subtitle,
      priority
    }
  }
`;
